import { render, staticRenderFns } from "./PresenceSelector.vue?vue&type=template&id=4643e1fe&scoped=true"
import script from "./PresenceSelector.vue?vue&type=script&lang=js"
export * from "./PresenceSelector.vue?vue&type=script&lang=js"
import style0 from "./PresenceSelector.vue?vue&type=style&index=0&id=4643e1fe&prod&lang=scss&scoped=true"
import style1 from "./PresenceSelector.vue?vue&type=style&index=1&id=4643e1fe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4643e1fe",
  null
  
)

export default component.exports